import Link from "next/link";
import { footerDestinations } from "@/app/lib/home/data";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12 px-8">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <h3 className="text-xl font-bold mb-4">AI Trip Maker</h3>
          <p className="text-gray-400">
            Your personal AI-powered travel companion for creating perfect
            itineraries in seconds.
          </p>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Popular Destinations</h3>
          <ul className="space-y-2">
            {footerDestinations.map((destination) => (
              <li key={destination.name}>
                <Link
                  href={`/show/${destination.slug}`}
                  className="text-gray-400 hover:text-white transition hover:cursor-pointer"
                  title={`Itinerary for ${destination.name}`}
                  aria-label={`Itinerary for ${destination.name}`}
                >
                  {destination.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-2">
            <li>
              <Link
                href="/"
                className="text-gray-400 hover:text-white transition"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                href="/blog"
                className="text-gray-400 hover:text-white transition"
              >
                Blog
              </Link>
            </li>
            <li>
              <Link
                href="/trending"
                className="text-gray-400 hover:text-white transition"
              >
                Trending Trips
              </Link>
            </li>
            <li>
              <Link
                href="/itineraries"
                className="text-gray-400 hover:text-white transition"
              >
                Itineraries
              </Link>
            </li>
            <li>
              <Link
                href="/about"
                className="text-gray-400 hover:text-white transition"
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                href="mailto:contact@smartupai.com"
                className="text-gray-400 hover:text-white transition"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Stay Connected</h3>
          <div className="flex space-x-4">
            <a
              href="https://www.facebook.com/smartupai"
              className="text-gray-400 hover:text-white transition"
              target="_blank"
            >
              <svg
                className="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </a>
            <a
              href="https://www.youtube.com/watch?v=nWhjqX6U5Pc"
              className="text-gray-400 hover:text-white transition"
              target="_blank"
            >
              <svg
                className="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M21.8 8.001s-.2-1.436-.8-2.07c-.767-.855-1.626-.86-2.02-.911C16.32 4.814 12 4.814 12 4.814h-.02s-4.32 0-6.98.206c-.393.051-1.253.056-2.02.91-.6.635-.8 2.07-.8 2.07S2 9.733 2 11.465v1.07c0 1.732.2 3.464.2 3.464s.2 1.436.8 2.07c.767.855 1.776.829 2.225.92C7.68 19.186 12 19.186 12 19.186h.02s4.32 0 6.98-.206c.393-.051 1.253-.056 2.02-.91.6-.635.8-2.07.8-2.07s.2-1.732.2-3.464v-1.07c0-1.732-.2-3.464-.2-3.464zM9.75 15.017V8.983L15.5 12l-5.75 3.017z"></path>
              </svg>
            </a>
            <a
              href="https://x.com/smartupai"
              className="text-gray-400 hover:text-white transition"
              target="_blank"
            >
              <svg
                className="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-8 pt-8 border-t border-gray-800 text-center text-gray-400 flex flex-col md:flex-row justify-between">
        <p>© {new Date().getFullYear()} SmartUp AI LLC.</p>
        <div className="mt-4 md:mt-0">
          <Link
            href="/privacy"
            className="text-gray-400 hover:text-white transition mr-4"
          >
            Privacy
          </Link>
          <Link
            href="/terms"
            className="text-gray-400 hover:text-white transition"
          >
            Terms
          </Link>
        </div>
      </div>
    </footer>
  );
}
